import { NavLink } from "react-router-dom";

import { spaces } from "emoreg/const";
import { rem } from "polished";
import styled, { css } from "styled-components";
import { radius } from "styles/const";

// Base styles that can be shared between link and button variants
const baseNavIconStyles = css`
  margin-left: ${spaces[16]};
  background: ${props => (props.isActive ? "#002a54" : "transparent")};
  border-radius: ${radius.base};
  padding: ${rem(7)} ${rem(13)};
  display: inline-block;
  border: none;
  cursor: pointer;
  & > span {
    color: white;
  }
  &:hover {
    text-decoration: none;
    background: #002a54;
  }
`;

export const NavRouterLinkIcon = styled(NavLink)`
  ${baseNavIconStyles}
  &.active {
    background: #002a54;
  }
`;

// Button variant for non-link actions
export const NavButtonIcon = styled.button`
  ${baseNavIconStyles}
`;
